import PropTypes from 'prop-types'

import idPropType from './id-prop-type'

const simpleEntityPropType = PropTypes.shape({
  id: idPropType.isRequired,
})

export default simpleEntityPropType
